module.exports = __webpack_public_path__ + "img/x2.254d1bf4.jpg";